const delay = (ms: number): Promise<void> =>
  new Promise((resolve) => {
    setTimeout(resolve, ms);
  });

/**
 * Repeatedly calls `refetch`, applies `predicate` to the result,
 * and returns the first truthy value. Returns `null` after
 * `maxAttempts` failures.
 */
export async function pollForResult<TData, TResult>(options: {
  refetch: () => Promise<TData>;
  predicate: (data: TData) => TResult | null | undefined;
  maxAttempts?: number;
  intervalMs?: number;
}): Promise<TResult | null> {
  const { refetch, predicate, maxAttempts = 4, intervalMs = 500 } = options;

  /* eslint-disable no-await-in-loop -- intentional sequential polling */
  for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
    const data = await refetch();
    const result = predicate(data);
    if (result) return result;
    if (attempt < maxAttempts - 1) await delay(intervalMs);
  }
  /* eslint-enable no-await-in-loop */

  return null;
}
